import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Hematologist = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="hematologist icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7226 0C21.7226 0 23.562 3.12004 23.562 4.13573C23.562 5.15142 22.7383 5.97511 21.7226 5.97511C20.705 5.97511 19.8813 5.15142 19.8813 4.13573C19.8813 3.12004 21.7226 0 21.7226 0ZM27.4573 12.0831C27.4573 10.741 25.0285 6.62451 25.0285 6.62451C25.0285 6.62451 22.5996 10.741 22.5996 12.0831C22.5996 13.4252 23.6883 14.5139 25.0285 14.5139C26.3706 14.5139 27.4573 13.4252 27.4573 12.0831ZM24.2247 48C19.8797 48 16.3431 44.4633 16.3431 40.1202V21.0057C16.3427 20.9928 16.3425 20.9799 16.3425 20.9668C16.3425 20.9538 16.3427 20.9409 16.3431 20.928V13.4242C16.3431 13.0613 16.0474 12.7637 15.6826 12.7637C14.9741 12.7637 14.4 12.1915 14.4 11.4811C14.4 10.7726 14.9741 10.2005 15.6826 10.2005C17.4605 10.2005 18.9063 11.6462 18.9063 13.4242V19.6862H26.6472C27.3557 19.6862 27.9298 20.2584 27.9298 20.9668C27.9298 21.6753 27.3557 22.2494 26.6472 22.2494H18.9063V25.1227H22.1379C22.8464 25.1227 23.4185 25.6968 23.4185 26.4033C23.4185 27.1118 22.8464 27.6878 22.1379 27.6878H18.9063V30.5605H22.1379C22.8464 30.5605 23.4185 31.1326 23.4185 31.8411C23.4185 32.5496 22.8464 33.1237 22.1379 33.1237H18.9063V35.998H22.1379C22.8464 35.998 23.4185 36.5721 23.4185 37.2806C23.4185 37.989 22.8464 38.5631 22.1379 38.5631H18.9063V40.1202C18.9063 43.0521 21.2929 45.4367 24.2247 45.4367C27.1547 45.4367 29.5432 43.0521 29.5432 40.1202V13.4088C29.5432 11.6328 30.989 10.1851 32.7669 10.1851C33.4754 10.1851 34.0495 10.7592 34.0495 11.4677C34.0495 12.1762 33.4754 12.7483 32.7669 12.7483C32.4021 12.7483 32.1045 13.0459 32.1045 13.4088V40.1202C32.1045 44.4633 28.5717 48 24.2247 48Z"
    />
  </svg>
)
